'use strict';

/**
 * Defines the properties and methods that every child transform class should
 * implement.
 * 
 * NOTE: This should not be used directly
 */

module.exports = {

  /**
   * The key on the layer under which the GeoJSON data is stored
   * @type {String}
   */
  geojsonKey: 'data',

  /**
   * Return the collection to be parsed. Only necessary if the you are parsing
   * a collection
   *
   * NOTE: `getCollection` and `getModel` are mutually exclusive
   * 
   * @param  {Object} data 
   * @return {Object|Array}
   */
  getCollection: function (data) {
    /* jshint unused:false */
  },

  /**
   * Return the model to be parsed. Only necessary if you are parsing a model.
   * 
   * NOTE: `getCollection` and `getModel` are mutually exclusive
   * 
   * @param  {[type]} data [description]
   * @return {[type]}      [description]
   */
  getModel: function (data) {
    /* jshint unused:false */
  },

  /**
   * Default layer styles for different states. Should return an object with  
   * three states (properties): active, default, dim
   * 
   * @return {Object} 
   */
  getLayerStateStyles: function (rlayer) {
    /* jshint unused:false */
  },

  /**
   * Transform a layer type into a type that leaflet understands.
   * Should return one of [circle, marker, polygon, polyline, rectangle]. 
   *
   * @param  {Object} rlayer  Raw layer data
   * @return {String} type {circle|marker|polygon|polyline|rectangle}
   */
  getLeafletTypeFromLayer: function (rlayer) {
    /* jshint unused:false */
  },

  isLayerClickable: function (rlayer) {
    /* jshint unused:false */
    return true;
  },

  isLayerEditable: function (rlayer) {
    /* jshint unused:false */
    return true;
  },

  /**
   * This is a callback function executed when Leaflet is generating the layer
   * from the GeoJSON data and is used to convert a `point` into the appropriate
   * LeafletLayer type.
   *
   * @param  {Object} rlayer  Raw layer data
   * @param  {Object} renderOptions Object containing additional render info
   * @param  {Object} feature GeoJSON feature
   * @param  {Object} latlng  LatLng object
   * @return {Object} LeafletLayer
   */
  pointToLayerFn: function (rlayer, renderOptions, feature, latlng) {
    /* jshint unused:false */
  },

  /**
   * This is a callback function executed when Leaflet is generating the layer 
   * and used to retrieve the LeafletLayer constructor options. This only applies
   * to path `layers` (not markers).
   * 
   * @param  {Object} rlayer  Raw layer data
   * @param  {[type]} feature [description]
   * @return {[type]}         [description]
   */
  styleFn: function (rlayer, feature) {
    /* jshint unused:false */
    return {};
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/_Interface.js